// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "asset_analysis".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { assetAnalysisStatusValues, assetContentTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "asset_analysis" table (1:1 with a DB row, on the wire). */
export const assetAnalysisAtomSchema = z.object({
    id: z.string(),
    assetId: z.string(),
    status: z.enum(assetAnalysisStatusValues),
    contentType: z.enum(assetContentTypeValues).nullable(),
    analysisResult: z.unknown().nullable(),
    errorMessage: z.string().nullable(),
    queuedAt: z.string().datetime(),
    startedAt: z.string().datetime().nullable(),
    completedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=assetAnalysis.js.map